import styled from 'styled-components';
import { getEasyLayout } from '@resistdesign/voltra/app/utils';

export const {
  layout: CenteredScreenLayout,
  areas: { EmptyHeader, EmptyCenterLeft, CenterContent, EmptyCenterRight, EmptyFooter },
} = getEasyLayout(styled.div`
  flex: 1 0 auto;
  min-height: 100%;
`)`
  empty-header empty-header empty-header, 1fr
  empty-center-left center-content empty-center-right, auto
  empty-footer empty-footer empty-footer, 1fr
  \\ 1fr 50% 1fr
`;

export const CenterContentControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
`;

export const StructuredText = styled.div``;
